import React, { useState } from "react"
import { usePasswordlessLogin } from "api-hooks/index"

export const PasswordlessSignInContainer = () => {
  const loginMutator = usePasswordlessLogin()
  const [email, setEmail] = useState("")

  return (
    <span
      style={{
        textAlign: "center",
        padding: 16,
        border: "1px solid #888",
        margin: "0 auto",
        width: "400px",
        display: "block",
      }}
    >
      <input
        type="text"
        value={email}
        placeholder="email"
        onChange={(e) => setEmail(e.target.value)}
      />
      <button
        onClick={() => {
          loginMutator.mutate({ email })
          window.location.href = "/"
        }}
      >
        Sign In with Passwordless
      </button>
    </span>
  )
}
